export enum SummaryReportGroupByOption {
    none = 'none',
    responsibility = 'responsibility',
    year = 'year'
}
